var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('div',{staticClass:"title-text"},[_vm._v(_vm._s(_vm.titleText))]),_c('div',{staticClass:"title-line"}),_c('div',{staticClass:"sub-title-text"},[_vm._v(_vm._s(_vm.subTitleText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }